<h1 mat-dialog-title>{{ 'common.fileUploader.title' | translate }}
  <span class="text-muted" [ngClass]="{ 'd-none': !data.title }"> - {{ data.title }}</span>
</h1>
<div class="row">
  <div class="col-12">
    <mat-dialog-content>
      <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
      <div>
        <p><strong class="custom-label">Percorso:</strong> {{ savePath }}/</p>
      </div>
      <div class="form-wrapper">
        <form [formGroup]="form">
          <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
        </form>
      </div> <!-- /.form-wrapper -->
    </mat-dialog-content> <!-- mat-dialog-content -->
  </div>
</div>
<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6">
    <mat-spinner-button (btnClick)="onFormSubmit()" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <a mat-button (click)="onClose()" mat-raised-button mat-default class="ml-3">{{ 'common.cta.undo' | translate }}</a>
  </div> <!-- /.col -->
</div> <!-- /.row -->